// Generated by scripts/stats/update_language_stats.js@inventaire-i18n
export default {
  ar: {
    completion: 58,
    defaultRegion: 'ar_AR'
  },
  bn: {
    completion: 72,
    defaultRegion: 'bn_BN'
  },
  ca: {
    completion: 99,
    defaultRegion: 'ca_CA'
  },
  cs: {
    completion: 44,
    defaultRegion: 'cs_CS'
  },
  da: {
    completion: 50,
    defaultRegion: 'da_DK'
  },
  de: {
    completion: 99,
    defaultRegion: 'de_DE'
  },
  el: {
    completion: 7,
    defaultRegion: 'el_EL'
  },
  en: {
    completion: 100,
    defaultRegion: 'en_US'
  },
  eo: {
    completion: 17,
    defaultRegion: 'eo_EO'
  },
  es: {
    completion: 99,
    defaultRegion: 'es_ES'
  },
  fi: {
    completion: 7,
    defaultRegion: 'fi_FI'
  },
  fr: {
    completion: 98,
    defaultRegion: 'fr_FR'
  },
  hu: {
    completion: 12,
    defaultRegion: 'hu_HU'
  },
  id: {
    completion: 62,
    defaultRegion: 'id_ID'
  },
  it: {
    completion: 82,
    defaultRegion: 'it_IT'
  },
  ja: {
    completion: 46,
    defaultRegion: 'ja_JP'
  },
  nb: {
    completion: 9,
    defaultRegion: 'nb_NB'
  },
  nl: {
    completion: 56,
    defaultRegion: 'nl_NL'
  },
  pa: {
    completion: 7,
    defaultRegion: 'pa_PA'
  },
  pl: {
    completion: 54,
    defaultRegion: 'pl_PL'
  },
  pt: {
    completion: 12,
    defaultRegion: 'pt_PT'
  },
  ro: {
    completion: 89,
    defaultRegion: 'ro_RO'
  },
  ru: {
    completion: 65,
    defaultRegion: 'ru_RU'
  },
  sk: {
    completion: 24,
    defaultRegion: 'sk_SK'
  },
  sv: {
    completion: 99,
    defaultRegion: 'sv_SE'
  },
  th: {
    completion: 4,
    defaultRegion: 'th_TH'
  },
  tr: {
    completion: 48,
    defaultRegion: 'tr_TR'
  },
  uk: {
    completion: 68,
    defaultRegion: 'uk_UK'
  }
} as const